import useMaps from '../hooks/useMaps';

import { useAtom } from 'jotai';
import { showMapsViewAtom } from '../states/planner';

export const MapButton = () => {
  const [, setShowMapsView] = useAtom(showMapsViewAtom);
  const [maps] = useMaps();

  if (!maps || maps.length == 0) return null;

  return (
    <button
      onClick={() => setShowMapsView(true)}
      className="bottom-14 left-2 flex w-auto items-center gap-2 whitespace-nowrap rounded-md bg-black bg-opacity-50 px-3 py-1 text-sm text-white opacity-90 sm:origin-center sm:transform sm:transition sm:duration-100 sm:hover:scale-105"
    >
      Visa Karta
    </button>
  );
};
